import { PatientFlagsControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";
import { ArchiveMutation } from "../../../hooks/useArchiveState";

/**
 *
 * @author [Atish Bagate]
 */
export const usePatientFlagArchive = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new PatientFlagsControllerApi(getConfigObject()).updatePatientFlagArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
